import React from 'react';
import { useFormContext } from 'react-hook-form';
import Title from 'src/refactor_components/common/Title';

const CurriculumNonRegular = () => {
  const { register } = useFormContext();

  return (
    <>
      <div className="flex flex-col gap-8 items-start">
        <Title text="수업 횟수" essential />
        <input
          {...register('price')}
          className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
          placeholder={'가격을 입력해 주세요'}
        />
      </div>
      <div className="flex flex-col gap-8 items-start">
        <Title text="수업 가격" essential />
        <input
          {...register('price')}
          className="focus:bg-white focus:text-black w-full bg-transparent p-10 text-16 rounded-[5px] h-53 placeholder:text-[#999] border border-solid border-[var(--color-gray-second)]"
          placeholder={'가격을 입력해 주세요'}
        />
      </div>
    </>
  );
};

export default CurriculumNonRegular;
